import ModuleModals from './module-modals';

export default {
    ModuleModals
}